import { aemContentPath, homePageJson } from "Constant/apiConstant";
import {
  FETCH_LABELS_AND_PLACEHOLDER,
  FETCH_LABELS_AND_PLACEHOLDER_SUCCESS,
  FETCH_LABELS_AND_PLACEHOLDER_FAILED,
} from "../Constants/HomePageConstant";
import axios from "axios";


function fetchingLabelsAndPlaceholder(payload) {
  return {
    type: FETCH_LABELS_AND_PLACEHOLDER,
    payload,
  };
}

function fetchingLabelsAndPlaceholderSuccess(payload) {
  return {
    type: FETCH_LABELS_AND_PLACEHOLDER_SUCCESS,
    payload,
  };
}

function fetchingLabelsAndPlaceholderFailed(payload) {
  return {
    type: FETCH_LABELS_AND_PLACEHOLDER_FAILED,
    payload,
  };
}

export const fetchLabelsAndPlaceholder =
  (payload, callback) => (dispatch, getState) => {
    dispatch(fetchingLabelsAndPlaceholder());

    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}${aemContentPath}${homePageJson}`
      )
      .then((res) => {
        console.log("res", res);
        if (res?.data?.code === 200) {
          dispatch(fetchingLabelsAndPlaceholderSuccess(res?.data?.data));
        } else {
          dispatch(fetchingLabelsAndPlaceholderFailed(res));
        }
      })
      .catch((error) => {});
  };
